module.exports = __webpack_public_path__ + "static/media/back-mobile.5b7cf77b.svg";